module.exports = __webpack_public_path__ + "img/range1.ce823790.png";